import { Label, Stack, IStyle } from "@fluentui/react";
import React from "react";

import { Text } from "../Text";

export interface LabeledTextProps {
    label: string;
    textTooltip?: boolean;
    textColor?: string;
    value?: string | number;
    maxLength?: number;
    testId?: string;
    direction?: "vertical" | "horizontal";
    labelFontSize?: number | string;
    labelFontWeight?: string;
    textFontSize?: number | string;
    textFontWeight?: string;
    labelStyle?: IStyle;
    textStyle?: IStyle;
    nowrap?: boolean;
}

export const LabeledText: React.FunctionComponent<LabeledTextProps> = (props: LabeledTextProps) => {
    const {
        label,
        textTooltip,
        textColor,
        value,
        maxLength,
        testId,
        direction = "vertical",
        labelFontSize,
        labelFontWeight,
        textFontSize,
        textFontWeight,
        labelStyle,
        textStyle,
        nowrap
    } = props;

    const stackStyles = {
        root: {
            marginBottom: direction === "horizontal" ? 5 : 10,
            flexDirection: direction === "horizontal" ? "row" : "column",
            alignItems: direction === "horizontal" ? "start" : undefined,
            gap: 4
        }
    };

    const mergedLabelStyle: IStyle = mergeIStyle(
        {
            fontSize: labelFontSize,
            fontWeight: labelFontWeight,
            padding: 0
        },
        labelStyle
    );

    const mergedTextStyle: IStyle = mergeIStyle(
        {
            color: textColor,
            fontSize: textFontSize,
            fontWeight: textFontWeight
        },
        textStyle
    );

    return (
        <Stack data-testid={testId} styles={stackStyles}>
            <Label data-testid={testId ? `${testId}-label` : undefined} styles={{ root: mergedLabelStyle }}>
                {label}
            </Label>
            <Text
                testId={testId ? `${testId}-text` : undefined}
                tooltip={value && textTooltip ? value.toString() : undefined}
                nowrap={nowrap}
                maxLength={maxLength}
                styles={{ root: mergedTextStyle }}
                value={value ? value.toString() : "-"}
            />
        </Stack>
    );
};

const mergeIStyle = (base: IStyle, extra?: IStyle): IStyle => {
    if (extra && typeof extra === "object" && !Array.isArray(extra)) {
        return Object.assign({}, base, extra);
    }
    return base;
};
